/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { StructFlex, StructItem } from '@cybs-ui/components/lib/struct-flex';
import CybsIcon from '@cybs-ui/components/lib/icon';

const DefaultEmptyView = props => {
  const { i18n } = props;
  return (
    <StructFlex
      css={theme => css`
        max-width: 100%;
        height: 250px;
        && svg {
          use,
          use path {
            fill: ${theme?.variables?.colors?.status?.warning?.default};
          }
        }
      `}
      align-items="center"
      justify-content="center"
      direction="column"
      id="empty-view-container"
    >
      <StructItem>
        <CybsIcon dataTest="no-rows-icon" name="warning" resolution="high" />
      </StructItem>
      <StructItem
        css={theme =>
          css`
            ${theme.classes.typography.text.weight['600']};
          `
        }
      >
        {i18n.title}
      </StructItem>
      <StructItem>{i18n.subtitle}</StructItem>
    </StructFlex>
  );
};

DefaultEmptyView.displayName = 'defaultEmptyView';
DefaultEmptyView.propTypes = {
  // Translated values for titles
  i18n: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string
  }).isRequired
};

export default DefaultEmptyView;
